/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Preview_TooltipInputs */



/**
* | output |
* | --- |
* | "Preview and export document" |
*
* @param {Editor_Preview_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_preview_tooltip = /** @type {((inputs?: Editor_Preview_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Preview_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dokument anzeigen und exportieren")
	return /** @type {LocalizedString} */ ("Preview and export document")
});